import { ButtonStyle, ControlSize, ControlType, Property, PropertyType } from "../../../base/types";
import * as authHelper from './../../../../modules/auth/core/AuthHelpers'

import { DefaultLabel } from "../../widgets";
import { DesignerMode } from "../../types";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { Registry } from "../../../base/register";
import clsx from "clsx";
import { getButtonClass } from "../buttons/helper";
import { useGetProperties } from "../../../base/hooks";
import { getBaseUrl } from "../../page-actions/url-helper";

export const HyperLinkComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { token } = authHelper.getAuth() || {}
    const { properties } = useGetProperties({ bindings: control.bindings });
    const label: string | undefined = properties[Property.Label];
    const tooltip: string | undefined = properties[Property.Tooltip];
    const url: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];
    const icon: string | undefined = properties[Property.MaterialIcon]
    const style: ButtonStyle | undefined = properties[Property.BackgroundStyle]
    const size: ControlSize | undefined = properties[Property.Size]
    const portalURL: boolean | undefined = properties[Property.IsChecked]

    if (designerMode === DesignerMode.Draft) {
        return (
            <div className={clsx(getButtonClass(style, size, "btn btn-link btn-sm"), className)} title={tooltip}>
                {(icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                <DefaultLabel
                    control={control}
                    propertyId={Property.Label}
                    defaultLabel="Hyper Link"
                    className="text-hover-primary bg-secondary" />
                {children}
            </div>)
    }

    const base64Token = btoa(token || '')

    return (
        <>
            {
                (portalURL && url) ? <a
                    className={clsx(className, "btn btn-secondary btn-sm")}
                    target={target || undefined}
                    href={`${getBaseUrl(url)}/auth/token-auth(${encodeURIComponent(base64Token)})`}>
                    {icon && <MUIIcon iconName={icon} className="me-1" />}
                    <span>{label}</span>
                </a> :
                    <a className={clsx(getButtonClass(style, size, "btn btn-link btn-sm"), className)} title={tooltip} href={url} target={target}>
                        {(icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                        <span>{label}</span>
                        {children}
                    </a >
            }
        </>
    )
}

Registry.addControl({
    id: "1cd84e2f-d110-431c-a96f-b7e6555411af",
    name: "Hyperlink",
    type: ControlType.Hyperlink,
    properties: [
        { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
        { id: Property.Label, name: 'Label', type: PropertyType.String },
        { id: Property.Url, name: 'Url', type: PropertyType.String },
        { id: Property.Target, name: 'Target', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
        { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.ButtonStyle },
        { id: Property.Size, name: 'Size', type: PropertyType.ControlSize },
        { id: Property.IsChecked, name: 'Portal URL', type: PropertyType.Boolean },
    ],
    component: HyperLinkComponent
})
